import { setCartItemLocal } from '../../utils/localStorage';
import { cartAction } from '../actionType';

export const cartReducer = (state, action) => {
    switch (action.type) {
        case cartAction.UPDATE_CART:{
            let result = [];
            const data = action.payload.data;
            let isPresent = false;
            for(let i=0;i<state.length;i++){
                let quantity=state[i].quantity*1;
                let stock=state[i].stock*1;
                if(state[i].id===data.id && state[i].name ===data.name){
                    quantity=state[i].quantity*1 + action.payload.count;
                    if(action.payload.count<-1){
                        stock = quantity;
                    }
                    isPresent = true;
                }
                if(quantity!==0){
                    result.push({...state[i],quantity, stock});
                }
            }
            if(!isPresent){
                result = [...result, {...data, quantity:1}];
            }
            setCartItemLocal(result);
            return  result;
        }
        case cartAction.UPDATE_FULL_CART:{
            const data = action.payload.data;
            setCartItemLocal(data);
            return data ;
        }
        case cartAction.REMOVE_CART:{
            const removedIdList = action.payload.data.map(d=>d.id);
            const restCart = state.filter(d=>!removedIdList.includes(d.id));
            setCartItemLocal(restCart);
            return restCart ;
        }
           
        case cartAction.CLEAR_CART:
            setCartItemLocal([]);
            return [] ;
        default:
            return state;
    }
}